import apiService from "../api/ApiService"
import store from "../../vuex/AppStore"
import StoreType from "../../vuex/StoreType"
import bluetoothRepository from "../bluetooth/BluetoothRepository"
import log from "../log/log"

class DeviceRepository {

    async syncSmokeData(data) {
        const smokeData = {
            year              : data.year,
            month             : data.month,
            day               : data.day,
            deviceNumber      : data.deviceNumber,
            podId             : data.podId,
            timeSlot          : JSON.stringify(data.timeSlot),
            totalSmokeTime    : data.totalSmokeTime,
            userIdentification: data.userIdentification
        }

        // 失败了的数据存入数据库，以日期为key
        // 下次同步的时候，从数据库中读取出来，继续上传
        // 时间排序之后再上传
        try {
            const result    = await apiService.syncSmokeData(smokeData)
        }catch (e) {
            print('同步的时候发生了错误')
        }

    }

    async deviceConnection(batch, macAddress, podId) {
        return await apiService.deviceConnection({
            productionBatch  : batch,
            deviceNumber     : macAddress,
            smokeRecordNumber: podId
        })
    }


    async cartridgeInfo(podId) {
        const cartridgeInfoServer = await apiService.cartridgeInfo({
            smokeRecordNumber: podId
        })
        store.commit(StoreType.COMMIT_TYPE.COMMIT_CARTRIDGE_INFO_SERVER, cartridgeInfoServer)
        return cartridgeInfoServer
    }

    async diyTemperatureMode(podId) {
        const diyTemperatureList = await apiService.operatingModeList({
            smokeRecordNumber: podId
        })
        let data                 = []
        diyTemperatureList && diyTemperatureList.forEach((item, i) => {
            const name            = item.operatingModeName
            const temperatureData = []
            item.temperature.split(",").forEach((item, index) => {
                temperatureData.push({
                    x: (index + 1),
                    y: parseFloat(item)
                })
            })
            data.push({name, secondTemperature: temperatureData})
        })

        store.commit(StoreType.COMMIT_TYPE.COMMIT_DIY_TEMPERATURE_MODE, data)
        return data
    }

    async bindDevice(macAddress) {
        return await apiService.bindDevice(macAddress)
    }

    async unbindDevice(deviceId) {
        return await apiService.unbindDevice(deviceId)
    }

    async modifyDeviceName(deviceId, deviceName) {
        return await apiService.modifyDeviceName(deviceId, deviceName)
    }

    async getDeviceNameFromServer(macAddress, deviceName) {
        return await apiService.getDeviceNameFromServer(macAddress, deviceName)
    }

    async synchronizeTime(macAddress, deviceType, randomEncrypt) {
        return await apiService.synchronizeTime(macAddress, deviceType, randomEncrypt)
    }

    async smokeOilType() {
        return await apiService.getSmokeOilType()
    }

    async selectChartLineHistogram(status, oilType, startTime, pageNum = 1, pageSize = 10) {
        return await apiService.selectChartLineHistogram(status, oilType, startTime, pageNum, pageSize)
    }

    async temperatureMode(deviceRecordNumber) {
        return await apiService.temperatureMode(deviceRecordNumber)
    }


    async concentrateTypeList(smokeRecordNumber) {
        const data = await apiService.concentrateTypeList({smokeRecordNumber})
        store.commit(StoreType.COMMIT_TYPE.COMMIT_CONCENTRATE_TYPE, data)
        return data
    }


    async saveCustomDiyTemperature(id, temperature) {
        const data = await apiService.saveCustomDiyTemperature({id, temperature})
        return data
    }


    async chartLineSmokingTimeRecord(status, oilType, startTime, currentTime) {
        return await apiService.chartLineSmokingTimeRecord(status, oilType, startTime, currentTime)
    }


    async consultationList(podId,pageNum) {
        return await apiService.consulationList({
            smokeRecordNumber: podId,
            pageSize         : 10,
            pageNum,
        })
    }

    async otaCheck(hwVersion,cartridgeFlag) {
        return await apiService.otaCheck(hwVersion,cartridgeFlag)
    }
}

const deviceRepository = new DeviceRepository()
export default deviceRepository
